import { dateValueFormatter, numberValueFormatter } from '../../../../../util/formatter';

export default function ElectiontypesTableColumnDefinition(local) {
  return [{
    type: 'string',
    field: 'name',
    headerName: local.name,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'key',
    headerName: local.key,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'number',
    field: 'electionresults',
    headerName: local.electionresults,
    valueFormatter: numberValueFormatter,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'description',
    headerName: local.description,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'date',
    field: 'updatedAt',
    headerName: local.updatedAt,
    valueFormatter: dateValueFormatter,
    minWidth: 150,
    flex: 1,
  }, {
    type: 'string',
    field: 'editor',
    headerName: local.editor,
    minWidth: 150,
    flex: 1,
  }];
}
